import axios from "axios";
import { enqueueSnackbar } from "notistack";
import store from "../redux/store";
import { logoutSuccess } from "../slices/authSlice";

// AUTH-35 / rule 10.1: one place reacts to an ended session, a refused action and a server failure. The API answers 401 when the token is missing,
// expired, logged out, outside the login window or the user was disabled; the session is cleared once and the
// Session Expired page is shown instead of every page failing on its own.
let redirecting = false;

export const installSessionInterceptor = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url || "";
      const isAuthCall = /\/(login|checkuser|logout)$/.test(url);
      if (status === 401 && !isAuthCall) {
        if (!redirecting) {
          redirecting = true;
          store.dispatch(logoutSuccess());
          window.location.assign("/session-timeout");
        }
        // the page is being replaced; keep its pending calls quiet instead of surfacing errors
        return new Promise(() => {});
      }
      // FIX_RULES 10.1 (NEW-83): one message for a refused action and for a server failure, whatever page made the
      // call (pages showed nothing or "Something went wrong"); the page's own handling still runs
      if (!isAuthCall && (status === 403 || status >= 500)) {
        const body = error?.response?.data || {};
        const said = typeof body.message === "string" ? body.message : typeof body.msg === "string" ? body.msg : "";
        enqueueSnackbar(
          status === 403
            ? said || "You do not have permission for this action."
            : `The server could not complete this (error ${status}). Please try again; if it keeps happening, tell the administrator.`,
          { variant: "error", preventDuplicate: true }
        );
      }
      return Promise.reject(error);
    }
  );
};
